<template>
  <div class="all">
    <div class="nei">

      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content"><p class="p1">{{ introductionData.p1 }}</p></div>
          <div class="lineBox"></div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p2">{{ introductionData.p2 }}</p></div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="grid-content">
            <div class="iconBox" @click="handleMore">
              <el-image
                src="http://116.62.38.250//image/sy/icon.png"
                :fit="contain"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content"><p class="p3">{{ introductionData.p3 }}</p></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style>
.iconBox{
  height: 100%;
  margin-top: 10px;
}
.lineBox {
  height: 2px;
  width: 106px;
  background: #d8d8d8;
  margin-top: 20px;
}
.p1 {
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #333333;
  text-align: justify;
}

.p2 {
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: justify;
  line-height: 28px;
}

.p3 {
  font-family: SourceHanSansCN;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.2px;
  text-align: justify;
  line-height: 24px;
}

.all {
  width: 100%;
  min-height: 460px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  background-color: #FFFFFF;
}

.nei {
  width: 1176px;
  min-height: 297px;
  background-color: #FFFFFF;
}
</style>
<script>
export default {
  name: "introduction",
  data() {
    return {
      introductionData: {
        p1: "公司简介",
        p2: "微创未来(北京)激光技术有限公司成立于2014年，专注于全线口腔激光治疗设备和配套耗材的研发、生产和销售。目前公司在北京、苏州分别建立了研发和生产基地。\n" +
          "多年来，一直致力于研发高端口腔激光治疗设备的系列产品，并取得了80多项知识产权，公司在激光领域拥有强大的创新能力和极高的市场敏锐度。",
        p3: "公司目前已取得国内首张口腔Er:YAG激光治疗领域的注册证，同时建立了国内首条口腔Er:YAG激光治疗仪的产品规模化生产线，为我们的产品提供了坚实的技术支撑，也提升了产品的核心竞争力。\n" +
          "微创未来，始终站在激光技术的前沿，不断探索、创新，公司将继续深耕口腔激光领域，秉承“超越客户期望，成就核心员工”的理念，不断提升产品的质量和性能，为口腔激光事业贡献更多的力量。   \n" +
          "选择微创未来，选择口腔健康的新未来，让我们一起，用一束光点亮口腔!",
        img: "../assets/gs.png"
      }
    }
  },
  methods:{
    //查看更多
    handleMore(){
      this.$router.push('/aboutUs?path=gsjj');
    }
  }
}
</script>

<style scoped>
.all{
  width: 1920px;
}
</style>



// WEBPACK FOOTER //
// src/components/image/introduction.vue